import React from "react";
import {
  EditController,
  EditView,
  Toolbar,
  SaveButton,
  DeleteButton,
  NumberInput,
  FormTab,
  TabbedForm,
  TextField
} from "react-admin";
import BaseballFormTab from "./BaseballFormTab";

const GamePlayerEdit = (props) => {
  const CustomToolbar = function (props) {
    const redirectPath = `/gamePlayers/${props.record.id}/show`;
    return (
      <Toolbar {...props}>
        <SaveButton redirect={redirectPath} />
        <DeleteButton undoable={false} redirect={redirectPath} />
      </Toolbar>
    );
  };

  return (
    <EditController undoable={false} {...props}>
      {(controllerProps) => (
        <EditView undoable={false} {...props} {...controllerProps}>
          <TabbedForm toolbar={<CustomToolbar />}>
            <FormTab label="summary">
              <TextField source="id" />
              <TextField source="sportCode" />
            </FormTab>
            {controllerProps.record &&
              controllerProps.record.sportCode === "football" && (
                <FormTab label="football">
                  <TextField source="football.id" />
                  <NumberInput source="football.puntingYards" />

                  <NumberInput source="football.passingCompletions" />
                  <NumberInput source="football.passingCompletionPercentage" />
                  <NumberInput source="football.passingAttempts" />
                  <NumberInput source="football.passingInterceptions" />
                  <NumberInput source="football.passingYards" />
                  <NumberInput source="football.passingAverage" />
                  <NumberInput source="football.passingTouchdowns" />

                  <NumberInput source="football.rushingAttempts" />
                  <NumberInput source="football.rushingYards" />
                  <NumberInput source="football.rushingAverage" />
                  <NumberInput source="football.rushingTouchdowns" />

                  <NumberInput source="football.receptions" />
                  <NumberInput source="football.receivingYards" />
                  <NumberInput source="football.receivingAverage" />
                  <NumberInput source="football.receivingTouchdowns" />

                  <NumberInput source="football.fieldGoalAttempts" />
                  <NumberInput source="football.fieldGoalsMade" />
                  <NumberInput source="football.fieldGoalYards" />

                  <NumberInput source="football.totalPoints" />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "girls-volleyball" && (
                <FormTab label="volleyball">
                  <TextField source="girlsvolleyball.id" />
                  <NumberInput source="girlsvolleyball.kills" />
                  <NumberInput source="girlsvolleyball.blocks" />
                  <NumberInput source="girlsvolleyball.aces" />
                  <NumberInput source="girlsvolleyball.digs" />
                  <NumberInput source="girlsvolleyball.assists" />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "softball" && (
                <FormTab label="softball">
                  <BaseballFormTab />
                </FormTab>
              )}
            {controllerProps.record &&
              controllerProps.record.sportCode === "baseball" && (
                <FormTab label="baseball">
                  <BaseballFormTab />
                </FormTab>
              )}
          </TabbedForm>
        </EditView>
      )}
    </EditController>
  );
};

export default GamePlayerEdit;
